import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './xpolar.png'


_pushScopeId("data-v-77a7f28d")
const _hoisted_1 = { class: "sunrise-title py-10" }
const _hoisted_2 = { class: "flex-column" }
const _hoisted_3 = { class: "sunrise-title-text uppercase" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sunrise-subtitle-text title" }, "Single Stake", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "num-tokens" }
const _hoisted_7 = { class: "details" }
const _hoisted_8 = {
  key: 0,
  class: "mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-[24px] flex justify-center gap-[12px]"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "data-text text-right" }, [
  /*#__PURE__*/_createElementVNode("div", null, "APR:"),
  /*#__PURE__*/_createElementVNode("div", null, "Daily APR:")
], -1)
const _hoisted_11 = { class: "data-text" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  width: "80",
  height: "80"
}, null, -1)
const _hoisted_13 = { class: "num-tokens" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "details" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "uppercase" }, "xpolar"),
  /*#__PURE__*/_createTextVNode(" Earned")
], -1)
const _hoisted_15 = { class: "mt-[24px] flex justify-center gap-[12px]" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "w-full" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StakeModal = _resolveComponent("StakeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.sunrise.name), 1),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([{ info: _ctx.isDesktop, infoMobile: _ctx.isMobile }, "title"])
    }, " Earn XPOLAR by depositing " + _toDisplayString(_ctx.sunrise.name.toUpperCase()), 3),
    _createElementVNode("div", {
      class: _normalizeClass([{ sunrise: _ctx.isDesktop, sunriseMobile: _ctx.isMobile }, "justify-center text-center"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _createElementVNode("img", {
          class: "logo",
          src: _ctx.logo[_ctx.sunrise.name]
        }, null, 8, _hoisted_5),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.balance), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.sunrise.name.toUpperCase()) + " Staked", 1),
        (!_ctx.approved)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "claim-btn",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.approve && _ctx.approve(...args)))
              }, "Approve")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "claim-btn",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleStakeModal()))
              }, "Deposit"),
              _createVNode(_component_StakeModal, {
                depositBol: true,
                isVisible: _ctx.isStakeModalVisible,
                token: _ctx.sunrise.name.toUpperCase(),
                balance: _ctx.balanceFor(_ctx.tokenAddress),
                address: _ctx.tokenAddress,
                onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleStakeModal()))
              }, null, 8, ["isVisible", "token", "balance", "address"]),
              _createElementVNode("button", {
                class: "withdraw-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleUnstakeModal()))
              }, " Withdraw "),
              _createVNode(_component_StakeModal, {
                depositBol: false,
                isVisible: _ctx.isUnstakeModalVisible,
                token: _ctx.sunrise.name.toUpperCase(),
                balance: _ctx.balance,
                address: _ctx.tokenAddress,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleUnstakeModal()))
              }, null, 8, ["isVisible", "token", "balance", "address"])
            ]))
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ data: _ctx.isDesktop, dataMobile: _ctx.isMobile })
      }, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.APR) + "%", 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.DAILY_APR) + "%", 1)
        ])
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass({ card: _ctx.isDesktop, cardMobile: _ctx.isMobile })
      }, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.earned), 1),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "claim-btn",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.claim())),
            disabled: !(parseFloat(_ctx.earned) > 0)
          }, " Claim Rewards ", 8, _hoisted_16)
        ])
      ], 2),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("button", {
          class: "claim-btn",
          "text-center": "",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.withdrawEverything()))
        }, " Claim and withdraw ")
      ])
    ], 2)
  ], 64))
}